<div class="row">
  <div class="col-md-9 pt-1">
    <mat-form-field>
      <mat-label>Buscar producto</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
    </mat-form-field>

    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" matSort>
        <!-- ID Column -->
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
          <td mat-cell *matCellDef="let row">
            {{row.nombre}}
          </td>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="categoria">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Categoría </th>
          <td mat-cell *matCellDef="let row" class="price">
            <mat-chip-list>
              <mat-chip *ngIf="row.categoria"><span>{{row.categoria?.nombre}}</span></mat-chip>
            </mat-chip-list>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="precio">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Precio </th>
          <td mat-cell *matCellDef="let row" class="price">
            <span class="">
              {{row.precio | currency}}
            </span>
          </td>
        </ng-container>
        <!-- Name Column -->
        <ng-container matColumnDef="precio_sugerido">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Precio sug.</th>
          <td mat-cell *matCellDef="let row" class="price">
            <span class="" *ngIf="dolar_blue">
              {{row.precio_usd * dolar_blue | currency}}
            </span>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="costo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Costo</th>
          <td mat-cell *matCellDef="let row" class="price">
            <span class="">
              {{row.costo | currency}}
            </span>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="costo_sugerido">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Costo sug. </th>
          <td mat-cell *matCellDef="let row" class="price">
            <span class="" *ngIf="dolar_blue">
              {{row.costo_usd * dolar_blue | currency}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
          <td mat-cell *matCellDef="let row">

            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="view(row._id)">
                <mat-icon>remove_red_eye</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item (click)="edit(row._id)">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="delete(row._id)">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No hay productos con el nombre "{{input.value}}"</td>
        </tr>

      </table>

      <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
    </div>
    <button mat-flat-button color="accent" class="mt-2 w-100" (click)="add()">Nuevo producto</button>
  </div>
  <div class="col-md-3">
    <app-categories></app-categories>
  </div>
</div>